import { QUEST_DESC_1, QUEST_DESC_2 } from "../helpers/content";
import quest from '../assets/quest/quest.png'
import quest_item from '../assets/quest/quest_items.png'


export default function Quest() {
  return (
    <div className="wrapper">
      <div className="content">
        <div className="title">WEEKLY QUEST</div>
        <div className="description">{QUEST_DESC_1()}</div>
        <div className="img_box small">
          <img src={quest} alt="quest" />
        </div>
        <div className="description">{QUEST_DESC_2()}</div>
        <div className="img_box">
          <img src={quest_item} alt="quest" />
        </div>
      </div>
    </div>
  );
}
